import { useWindowSize } from "@hooks/useWindowSize";
import Card from "@particles/card/Card";
import { CardVariations, TemplateProps } from "@particles/card/utils/types";
import { ImagePresets } from "@routes/Article/components/ArticleThumbnail/utils/enums";
import { cn } from "@util/helpers";

/**
 * This is the template H of cards. Used to display the hightlighted article in one column.
 * https://www.figma.com/design/rmzJoZwUpb3iLm6lMDXJ2W/BT-MASTER--WEB-?node-id=1285-4304&t=F3zMz7kBIivSXhWp-4
 */
const TemplateH = ({
  className,
  cardProps,
  cardVariantOverride,
}: TemplateProps): React.ReactElement => {
  const { isScreenLG } = useWindowSize();

  const variant: CardVariations = {
    kicker: {
      color: cn("text-gray-515"),
      extraClass: cn("mb-1"),
    },
    image: {
      width: "w-1/2",
      position: "left",
      aspectRatio: "aspect-3x2",
      orientation: "landscape",
      filters: { w: ImagePresets.MEDIUM, h: 320, dpr: 1, f: "webp" },
      extraClass: "hidden lg:flex",
    },
    content: {
      width: "w-1/2",
      extraClass:
        "p-4 lg:pt-0 lg:pb-0 lg:pr-0 items-center lg:items-start text-center lg:text-left bg-gray-850 lg:bg-transparent text-white lg:text-gray-850",
      blurb: { extraClass: "text-gray-850", wrapperClassName: cn("lg:my-2") },
      updatedTimeColor: cn("text-gray-850"),
      updatedTimeWrapperClass: cn("mt-2 lg:mt-auto"),
    },
    title: {
      size: "text-4xl lg:text-6xl",
      color: "text-white lg:text-gray-850",
      extraClass: cn("font-bold"),
    },
    section: {
      extraClass: cn("mb-1"),
    },
    subscriberLabel: { extraClass: "mt-0 mb-1" },
  };

  return (
    <div
      data-testid="card-template-component"
      data-template="template-h"
      className={cn("stories grid grid-cols-1 gap-8", className)}
    >
      {cardProps.map((cardProp) => (
        <Card
          key={cardProp.id}
          {...cardProp}
          variations={cardVariantOverride || variant}
          thumbnail={cardProp.thumbnail}
          defaultImage={isScreenLG ? cardProp.defaultImage : undefined}
          className={cn(
            "relative",
            "after:absolute after:-bottom-4 after:h-[1px] after:w-full after:bg-gray-175"
          )}
        />
      ))}
    </div>
  );
};

export default TemplateH;
